<template>
  <div>
    <Transition v-if="fetchingData" name="slide-fade">
      <progress-indicator />
    </Transition>
    <div v-else :style="styles.pageColor">
      <shop-header :store-id="currentStoreDoc.ID" />
      <div class="row m-4 justify-content-center">
        <div class="col-lg-9 py-4">
          <form
            class="p-4 d-flex flex-wrap justify-content-center"
            @submit.prevent="submitForm"
          >
            <div class="container">
              <navigate-user-back />
            </div>
            <div class="container my-4">
              <h1>{{ $t("message.myAccount") }}</h1>
            </div>
            <my-detail ref="myDetail" :edit-model="detailModel" />
            <cards :dbuser="dbuser" />
            <div
              v-if="success"
              class="alert alert-primary p-4 mt-4 alert-color w-100"
              role="alert"
            >
              {{ $t("message.profileSavedSuccessfully") }}
            </div>
            <div
              v-if="hasError"
              class="alert alert-danger p-4 mt-4 alert-color w-100"
              role="alert"
            >
              {{ hasError }}
            </div>
            <div class="w-50" style="margin-top: 4rem">
              <button
                :disabled="loading"
                type="submit"
                class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-center align-items-center"
                :style="desktopStyles.btn"
              >
                {{ $t("message.saveChanges") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyDetail from "./MyDetail";
import cards from "./cards";
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/profile.js";
import shopHeader from "../../components/shop/partials/shopheader";
import navigateUserBack from "./partials/navigateUserBack";
import ProgressIndicator from "@/components/progressindicator";

export default {
  components: {
    MyDetail,
    cards,
    shopHeader,
    navigateUserBack,
    ProgressIndicator,
  },
  data() {
    return {
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
      },
      hasError: "",
      success: false,
      loading: false,
      oldPhone: "",
      fetchingData: false,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "desktopStyles",
      "currentStoreDoc",
      "styles",
      "dbuser",
    ]),
  },
  async mounted() {
    this.setStoreLoaded();
    if (this.user) {
      this.oldPhone = this.dbuser ? this.dbuser.Mobile : "";
      this.initModel();
    }
  },
  methods: {
    ...shared.methods,
  },
};
</script>
